import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import axios from "axios";
import Cookies from 'js-cookie';

// bootstrap css
import 'bootstrap/dist/css/bootstrap.min.css';

// react-quill css
import 'react-quill/dist/quill.snow.css';

// datepicker css
import "react-datepicker/dist/react-datepicker.css";

// timepicker css
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// SCSS
import './assets/scss/index.scss';

// Redux Store
import store from "./redux/store"

axios.interceptors.request.use((request) => {
    if (request.url) {
        request.url = process.env.REACT_APP_API_BACKEND_SERVER + request.url;
    }
    if (localStorage.getItem("token") && Cookies.get('token')) {
        request.headers['Authorization'] = `Bearer ${localStorage.getItem("token")}`;
    }
    return request;
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
